import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from 'src/app/shared/components/custom-snackbar/custom-snackbar.component';
import { EventLogActions } from '.';

@Injectable()
export class EventLogStoreEffects {
  constructor(private actions$: Actions, private snackBar: MatSnackBar) {}

  info$ = createEffect(() =>
    this.actions$.pipe(
      ofType<EventLogActions.Info>(EventLogActions.ActionTypes.INFO),
      map((action) => {
        this.snackBar.open(typeof action.payload === 'string' ? action.payload : action.payload.alert, '', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'left',
        });

        return new EventLogActions.EmptyAction();
      }),
    ),
  );

  success$ = createEffect(() =>
    this.actions$.pipe(
      ofType<EventLogActions.Success>(EventLogActions.ActionTypes.SUCCESS),
      map((action) => {
        this.snackBar.open(typeof action.payload === 'string' ? action.payload : action.payload.alert, '', {
          duration: 5000,
          panelClass: 'success',
          verticalPosition: 'bottom',
          horizontalPosition: 'left',
        });

        return new EventLogActions.EmptyAction();
      }),
    ),
  );

  warning$ = createEffect(() =>
    this.actions$.pipe(
      ofType<EventLogActions.Warning>(EventLogActions.ActionTypes.WARNING),
      map((action) => {
        this.snackBar.open(typeof action.payload === 'string' ? action.payload : action.payload.alert, '', {
          duration: 5000,
          panelClass: 'warning',
          verticalPosition: 'bottom',
          horizontalPosition: 'left',
        });

        return new EventLogActions.EmptyAction();
      }),
    ),
  );

  error$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<EventLogActions.Error>(EventLogActions.ActionTypes.ERROR),
        tap((action) => {
          this.snackBar.openFromComponent(CustomSnackbarComponent, {
            data: {
              title: typeof action.payload === 'string' ? action.payload : action.payload.alert,
              type: 'danger',
            },
            panelClass: 'danger',
            duration: 5000,
            horizontalPosition: 'start',
          });
        }),
      ),
    { dispatch: false },
  );
}
